import { render, staticRenderFns } from "./searchChooser.vue?vue&type=template&id=7b4c0bf3"
import script from "./searchChooser.vue?vue&type=script&lang=js"
export * from "./searchChooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports